import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { WebsiteStateService } from '../../../../../state-management/services/website-state.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-base-cards-contact',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './base-cards-contact.component.html',
    styleUrl: './base-cards-contact.component.scss'
})
export class BaseCardsContactComponent {
  public configuration = this.websiteState.configuration;

  constructor(private websiteState: WebsiteStateService ) { }



  sendEmail() {
    let email = this.configuration().contactData.email;
    window.location.href = `mailto:${email}`;
  }

  call() {
    let phone = this.configuration().contactData.phone;
    window.location.href = `tel:${phone}`;
  }

}
